import { GoogleAuthProvider } from 'firebase/auth';

/**
 * Google OAuth provider for Firebase Auth popup sign-in.
 *
 * Manual Firebase Console setup (required per environment):
 * 1. Authentication → Sign-in method → Enable Google
 * 2. Authentication → Settings → Authorized domains — add:
 *    - arevina.com (canonical production)
 *    - www.arevina.com if used
 *    - readyresponder.web.app (Firebase Hosting alias; keep authorized)
 *    - ready-responder---stage.web.app (staging)
 *    - localhost (local dev)
 * 3. Google Cloud Console → APIs & Services → Credentials
 *    → your OAuth 2.0 Client ID → Authorized JavaScript origins (and redirect URIs)
 *    must include https://arevina.com (and www if used), or Google SSO will fail on the canonical domain.
 *
 * Apple Sign-In is NOT configured yet. To add later:
 * 1. Apple Developer account ($99/year)
 * 2. Create a Service ID in Apple Developer portal
 * 3. Configure Sign In with Apple in Firebase Auth console
 * 4. Add domain verification file to Firebase Hosting (/.well-known/apple-developer-domain-association)
 * 5. Provide return URL and privacy policy URLs required by Apple
 * 6. Implement OAuthProvider('apple.com') with nonce per Firebase docs
 */
export const googleProvider = new GoogleAuthProvider();

googleProvider.setCustomParameters({
  prompt: 'select_account',
});
